/**
 * PATH: packages/email-hub/src/feature/pages/inbox-page/preserveListScroll.ts
 * FILE_ID: EMAIL-INBOX-PRESERVE-LIST-SCROLL-001
 * PURPOSE: Capture/restore inbox list scrollTop across mutation refetches.
 * WHY: Allocate/confirm paths historically called refetch() and the list
 *      jumped to the top; keep a safety net even when local patch is used.
 */

/** Capture current scrollTop from the inbox list scroller. */
export function captureListScrollTop(
  listEl: HTMLElement | null | undefined,
): number | null {
  if (!listEl) return null
  return listEl.scrollTop
}

/** Restore a previously captured scrollTop (no-op when null/missing el). */
export function restoreListScrollTop(
  listEl: HTMLElement | null | undefined,
  scrollTop: number | null | undefined,
): void {
  if (!listEl || scrollTop == null || !Number.isFinite(scrollTop)) return
  listEl.scrollTop = scrollTop
}
